import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ChartWrapper from './ChartWrapper';

const DonutChart = ({
    data,
    dataKey,
    nameKey,
    loading,
    title,
    isOrderStatus,
    chartType,
    link
}) => {
    const chartContent = () => {
        if (loading) {
            return (
                <div className="flex justify-center items-center h-64">
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                </div>
            );
        }

        if (!data || data.length === 0) {
            return (
                <div className="flex justify-center items-center h-64">
                    <p>No data available</p>
                </div>
            );
        }

        const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D'];

        const getStatusColor = (status) => {
            const colorMap = {
                'Confirmed': '#0088FE',
                'Paid': '#00C49F',
                'Pending': '#FFBB28',
                'Gross Sale': '#0088FE',
                'Net Sale': '#00C49F',
                'Tax Amount': '#FF8042',
                'Delivery Charges': '#FFBB28',
                'Discount': '#8884D8'
            };
            return colorMap[status] || '#8884D8';
        };
        const filteredDataWithOutCancel = data.filter(item => item[nameKey] !== 'Cancel')

        return (
            <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                    <Pie
                        data={filteredDataWithOutCancel}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey={dataKey}
                        nameKey={nameKey}
                    >
                        {data.map((entry, index) => {
                            return (<Cell
                                key={`cell-${index}`}
                                fill={isOrderStatus ? getStatusColor(entry[nameKey]) : COLORS[index % COLORS.length]}
                            />);
                        })}
                    </Pie>
                    <Tooltip formatter={(value) => [value, nameKey]} />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        );
    };

    return (
        <ChartWrapper
            title={title}
            link={link}
            chartData={data}
        >
            {chartContent()}
        </ChartWrapper>
    );
};

export default DonutChart;